var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1158 0.0123702C11.3131 0.00676755 11.5077 0.0577785 11.6747 0.158896C11.8417 0.260013 11.9736 0.406653 12.0536 0.58011C12.1335 0.753567 12.1579 0.945978 12.1235 1.1328C12.0892 1.31962 11.9978 1.49238 11.8609 1.62905L6.90349 6.69934C6.81059 6.79427 6.69835 6.86991 6.57388 6.92162C6.44942 6.97332 6.31535 7 6.17976 7C6.04416 7 5.90998 6.97332 5.78551 6.92162C5.66105 6.86991 5.54892 6.79427 5.45602 6.69934L0.498404 1.62905C0.404529 1.53857 0.330514 1.4309 0.280724 1.31242C0.230936 1.19395 0.206407 1.06707 0.208569 0.939312C0.210732 0.811554 0.239564 0.685513 0.293337 0.568656C0.34711 0.451798 0.424677 0.346502 0.521566 0.259004C0.618455 0.171506 0.732661 0.103587 0.857362 0.0592702C0.982061 0.0149536 1.11479 -0.00485909 1.24761 0.00100602C1.38042 0.00687113 1.51063 0.0382944 1.63058 0.0934147C1.75052 0.148535 1.85775 0.226231 1.94588 0.3219L6.17976 4.65179L10.4134 0.3219C10.503 0.22784 10.6115 0.151989 10.7321 0.0988268C10.8527 0.0456643 10.9831 0.0162671 11.1158 0.0123702Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDown);
export default __webpack_public_path__ + "static/media/ico_down.efd3e0cc97cf57c267f9d3a51352b96a.svg";
export { ForwardRef as ReactComponent };